// Begin JQuery
jQuery(document).ready(function ($) {
	'use strict';

	// smoothPageTransition();

	document.addEventListener('DOMContentLoaded', function () {

		// IE Hack
		if (navigator.userAgent.indexOf("MSIE") > -1) {
			document.body.classList.add("ie");
		}

	});

	hauteurPage();

	toggleMenu();

	subMenuOpen();

	blurify();

	// General
	scrollMenu();

	AOS.init({ once: true });

	smoothScroller();

	searchFormDisplayer();

	QASlideDown();
	resizeQA();

	newsletterRegistrationOptions();

	contactFormOptions();

	singleProductOptions();

	evenementsInscriptionManager();

	redirectIfCartIsEmpty();

	AutoCompleteSearch();

	reserverInscriptionOptions();

	$('form.wpcf7-form input[name="telephone"]').on('focusout, keyup', function () {
		validatePhoneNumber($('form.wpcf7-form input[name="telephone"]'));
	});

	$('form.wpcf7-form input[name="email"]').on('focusout, keyup', function () {
		validateEmail($('form.wpcf7-form input[name="email"]'));
	});

	// En cas de redimensionnement de la fenetre
	$(window).on('resize', function () {
		hauteurPage();
		resizeQA();

		if ($(window).width() >= 1019) {
			menuReset();
			$('#navigation').removeClass('active');
			$('#navigate').removeClass('active');
			if ($('#navigation nav li.menu-item-has-children ul.sub-menu--lvl-0').css('display')) {
				$('#navigation nav li.menu-item-has-children ul.sub-menu--lvl-0').removeAttr('style');
			}
		}
	});

	$(document).ready(function () {
		$('a[data-mfp-src]').magnificPopup({ type: 'image' });

		addProductColorToLabel();

		popupDisplayer();

	});

	$(window).scroll(function () {
		scrollMenu();
	});

	$(window).on('click', function () {

		/* Ferme les suggestions de l'autocomplete de la barre de recherche */
		if ($('.autocomplete-results ul li').length) {
			$('.autocomplete-results ul').html('');
			$('#search-form').css('overflow', 'hidden'); /* on supprime l'overflow visible pour cacher les suggestions et que le rendu de la barre soit "smooth" */
		}

		/* Ferme le aside shopping cart */
		if ($('#aside_sc').hasClass('open')) {
			$('#aside_sc').removeClass('open');
		}
	});

	/* Ajoute un effet de flou */
	function blurify() {

		$('#navigation nav li').each(function (e) {
			if ($(this).hasClass('menu-item-has-children')) {
				$(this).hover(function () {
					if ($(this).hasClass('active')) {
						$('main#main').addClass('has-blur');
						setTimeout(() => {
							$(this).addClass('noblur');
						}, "1000");
					} else {
						$('main#main').removeClass('has-blur');
						$(this).removeClass('noblur');
					}
				},
				)
			}
		})
	}

	/* Redimensionne colonne de droite */
	function hauteurPage() {
		if (!$('body').hasClass('home')) {
			var heightEcran = $(window).height();
			var heightMain = $("main#main").height();
			var heightContent = heightMain;
			var heightFooter = $("footer").height();

			if ($("main#main section#head").lenght) {
				var heightBreadcrumb = $("main#main section#head").height();
				var heightContent = heightMain + heightBreadcrumb;
			}

			if (heightContent < (heightEcran - heightFooter)) {
				$("main#main").height(heightEcran - heightFooter);
				// $("body").css("overflow", "hidden");
			} else {
				$("main#main").height("");
			}
		}
	}

	/* Affiche le menu en mode responsive */
	function toggleMenu() {
		$('#navigate .mobile-menu').on('click', function (e) {
			// e.preventDefault();
			// $('ul#menu').slideToggle();
			$('#navigate').toggleClass('active');
			$('#navigation').toggleClass('active');
		});
	}


	function subMenuOpen() {

		if ($(window).width() < 768) {

			$("ul.sub-menu--lvl-0").hide();

			// Header menu
			$('#navigation nav li.menu-item-has-children > a').click(function (e) {
				e.preventDefault();
				var $ul = $(this).siblings('ul');
				if ($ul.length > 0) {
					$ul.slideToggle(600);
					$(".sub-menu--lvl-0").not($ul).slideUp(400);
					return false;
				}
			});

			// Footer menu
			$('.footer__content .col_1_4 nav li > a').click(function (e) {
				e.preventDefault();
				var $ul = $(this).siblings('ul');
				if ($ul.length > 0) {
					$ul.slideToggle(600);
					$(".sub-menu").not($ul).slideUp(400);
					return false;
				}
			});

		}

		// $('#navigation nav li.menu-item-has-children > a, .footer__content .col_1_4 nav li.menu-item-has-children > a').on('click',function(e) {
		// 	if($(window).width() < 1019) {


		// 			$('#navigation nav li').each(function(e) {
		// 				if ($(this).hasClass('menu-item-has-children')) {
		// 					$(this).find('ul.sub-menu').slideUp();
		// 				}
		// 			})
		// 			$('.footer__content .col_1_4 nav li').each(function(e) {
		// 				if ($(this).hasClass('menu-item-has-children')) {
		// 					$(this).find('ul.sub-menu').slideUp();
		// 				}
		// 			})
		// 			// $('#navigation nav li.menu-item-has-children a ul').slideUp();
		// 			$(this).next('ul').stop().slideToggle();

		// 	} else {
		// 		if($('html.touch').length) {
		// 			if($(this).next('ul').length) {
		// 				e.preventDefault();
		// 			}
		// 		}
		// 	}
		// });

		$('#navigation nav li.menu-item-has-children').on('mouseenter', function (e) {
			if ($(window).width() > 1019) {
				$(this).addClass('active');
			}
		});
		$('#navigation nav li.menu-item-has-children').on('mouseleave', function (e) {
			e.preventDefault();
			if ($(window).width() > 1019) {
				$(this).removeClass('active');
			}
		});
	}

	function scrollMenu() {
		var windowTop = $(window).scrollTop();

		if (windowTop > 1) {
			$('body').addClass('scroll');
		} else {
			$('body').removeClass('scroll');
		}
	}

	function smoothScroller() {

		/* Smooth Scroll */
		/* https://github.com/cferdinandi/smooth-scroll */
		new SmoothScroll('a[href="#top"]', {
			speed: 1000,
			speedAsDuration: true,
			easing: 'easeInOutQuart'
		});

	}

	/* Affiche le formulaire de recherche dans la barre de navigation du header */
	function searchFormDisplayer() {
		$('#search-icon i').on('click', function () {
			$(this).toggleClass('active')
			$('body').toggleClass('search-open');
			$('body.search-open header #asider #search-form form label input').focus();
		})

		$('.screen-reader-text').on('click', function () {
			$('header #asider #search-form form').submit();
		});
	}

	/* Realise le slideUp / slideDown lorsqu'on clique sur un titre */
	function QASlideDown() {
		if ($('.qa').length) {
			$('.qa .q').on('click', function () {
				$(this).parent().toggleClass('active');
				$(this).parent().find('.a').slideToggle();
			});
		}
	}

	/* Redimensionne la hauteur des blocs sous le titre onResize */
	function resizeQA() {
		if ($('.qa').length) {
			var heightEcran = $(window).height();
			$("main#main").css('min-height', (heightEcran - 158));
		}
	}

	/* Script pour realiser une transition smooth entre les pages (passage vers fond blanc + logo)
	 *
	 * ********** DESACTIVE POUR LE MOMENT **********
	*/
	function smoothPageTransition() {
		setTimeout(function () {
			$('body').removeClass('notloaded');
		}, 1500);

		$(window).on('scroll', function () {
			$('#loader').css('top', $(window).scrollTop());
		});

		$('a').on('click', function (e) {
			if (this.href.indexOf('#') != -1) {
			} else {
				e.preventDefault();
				$('body').addClass('notloaded');
				window.location.href = this.href;
			}
		});
	}


	/* ==========================================================================
	   NEWSLETTER FORM
	
	   Parametres et options des formulaires d'inscription a la newsletter
	   ========================================================================== */
	function newsletterRegistrationOptions() {
		if ($('#newsletter form').length) {
			$('#newsletter form input[type="submit"]').on('click', function (e) {
				$('#rgpd-required').remove();
				if ($('#newsletter form #rgpd-compliance label input[name="rgpd-compliance[]"]').is(":checked")) {
					$('#newsletter form .cols').css('display', 'none');
				} else {
					e.preventDefault();
					$('#newsletter form #rgpd-compliance label .wpcf7-list-item-label').append('<span id="rgpd-required" style="color:red;font-size: 1.3rem;display: block;">(champ obligatoire)</span>');
					return;
				}
			});

			$(document).on('click', '#newsletter form .wpcf7-response-output.wpcf7-validation-errors', function () {
				$(this).css('display', 'none');
				$('#newsletter form .cols').css('display', 'block');
			});
		}
	}


	/* ==========================================================================
	   CONTACT FORM
	
	   Parametres et options des formulaires de contact
	   ========================================================================== */
	function contactFormOptions() {

		if ($('form.wpcf7-form').length) {

			/* Ajoute le lien vers la politique de confidentialite pour l'input checkbox de validation RGPD */
			if ($('form.wpcf7-form #rgpd-compliance').length) {
				var html = $('form.wpcf7-form #rgpd-compliance .wpcf7-list-item-label').html();
				$('form.wpcf7-form #rgpd-compliance .wpcf7-list-item-label').html(html.replace('En savoir +', '<br/><a href="/politique-confidentialite" target="_blank">En savoir +</a>'));
			}

			/* Verifie si tous les champs "obligatoires" sont renseignes (on effectue une verification ici afin de ne pas avoir a dupliquer le formulaires (pro et particulier) mais egalement pour les champs dynamiques participants) */
			$(".page-template-page-contact #contact form.wpcf7-form .wpcf7-submit").on('click', function (e) {
				e.preventDefault();

				$('.page-template-page-contact #contact form.wpcf7-form span[role="alert"]').remove();

				// on supprime les champs
				$('.page-template-page-contact #contact form.wpcf7-form input[name="entreprise_nom"] + span.wpcf7-not-valid-tip').remove();
				$('.page-template-page-contact #contact form.wpcf7-form input[name="entreprise_adresse"] + span.wpcf7-not-valid-tip').remove();
				$('.page-template-page-contact #contact form.wpcf7-form input[name="entreprise_cp"] + span.wpcf7-not-valid-tip').remove();
				$('.page-template-page-contact #contact form.wpcf7-form input[name="entreprise_ville"] + span.wpcf7-not-valid-tip').remove();
				$('#formulaire form.wpcf7-form .cols .wpcf7-form-control-wrap.agence + span.wpcf7-not-valid-tip').remove();
				$('.page-template-page-contact #contact form.wpcf7-form input[name="telephone"] + span.wpcf7-not-valid-tip').remove();

				var submitForm = true;

				// si la personne qui envoie l'email est un professionnel
				if ($('.page-template-page-contact #contact form.wpcf7-form input[name="user_type"]:checked').val() == 'Professionnel') {

					// alors on verifie que le nom et l'adresse de l'entreprise est bien renseignee
					if ($('.page-template-page-contact #contact form.wpcf7-form input[name="entreprise_nom"]').length && !$('.page-template-page-contact #contact form.wpcf7-form input[name="entreprise_nom"]').val()) {
						$('.page-template-page-contact #contact form.wpcf7-form input[name="entreprise_nom"]').after('<span role="alert" class="wpcf7-not-valid-tip">Un champ nécessaire n’a pas été rempli.</span>');
						submitForm = false;
						return;
					}
					if ($('.page-template-page-contact #contact form.wpcf7-form input[name="entreprise_adresse"]').length && !$('.page-template-page-contact #contact form.wpcf7-form input[name="entreprise_adresse"]').val()) {
						$('.page-template-page-contact #contact form.wpcf7-form input[name="entreprise_adresse"]').after('<span role="alert" class="wpcf7-not-valid-tip">Un champ nécessaire n’a pas été rempli.</span>');
						submitForm = false;
						return;
					}
					if ($('.page-template-page-contact #contact form.wpcf7-form input[name="entreprise_cp"]').length && !$('.page-template-page-contact #contact form.wpcf7-form input[name="entreprise_cp"]').val()) {
						$('.page-template-page-contact #contact form.wpcf7-form input[name="entreprise_cp"]').after('<span role="alert" class="wpcf7-not-valid-tip">Un champ nécessaire n’a pas été rempli.</span>');
						submitForm = false;
						return;
					}
					if ($('.page-template-page-contact #contact form.wpcf7-form input[name="entreprise_ville"]').length && !$('.page-template-page-contact #contact form.wpcf7-form input[name="entreprise_ville"]').val()) {
						$('.page-template-page-contact #contact form.wpcf7-form input[name="entreprise_ville"]').after('<span role="alert" class="wpcf7-not-valid-tip">Un champ nécessaire n’a pas été rempli.</span>');
						submitForm = false;
						return;
					}
				}

				// on verifie le numero de telephone
				// if ($('.page-template-page-contact #contact form.wpcf7-form input[name="telephone"]').val().length !== 10) {
				// 	$('.page-template-page-contact #contact form.wpcf7-form input[name="telephone"]').after('<span role="alert" class="wpcf7-not-valid-tip">Veuillez renseigner un numéro valide.</span>');
				// 	submitForm = false;
				// 	return;
				// }
				if (!validatePhoneNumber($('.page-template-page-contact #contact form.wpcf7-form input[name="telephone"]'))) {
					submitForm = false;
					return;
				}

				if (!validateEmail($('.page-template-page-contact #contact form.wpcf7-form input[name="email"]'))) {
					submitForm = false;
					return;
				}
				if ($('#formulaire form.wpcf7-form .cols .wpcf7-form-control-wrap.agence .select-selected').html() == '---') {
					$('#formulaire form.wpcf7-form .cols .wpcf7-form-control-wrap.agence').after('<span role="alert" class="wpcf7-not-valid-tip">Champ obligatoire.</span>');
					submitForm = false;
					return;
				}

				$('.page-template-page-contact #contact form.wpcf7-form input.wpcf7-validates-as-required').each(function () {
					if (!$(this).val()) {
						$(this).after('<span role="alert" class="wpcf7-not-valid-tip">Champ obligatoire.</span>');
						submitForm = false;
						return;
					}
				});

				if (!$('.page-template-page-contact #contact form.wpcf7-form #rgpd label input[name="rgpd-compliance[]"]').is(":checked")) {
					$('.page-template-page-contact #contact form.wpcf7-form #rgpd label').append('<span role="alert" class="wpcf7-not-valid-tip">Champ obligatoire.</span>');
					submitForm = false;
					return;
				}

				if (submitForm == true) {
					$(".page-template-page-contact #contact form.wpcf7-form").submit();
				}
			});
		}

		/* Script pour récupérer le json des agences et les ajouter au select "agence" sur la page "Contact" */
		if ($('.page-template-page-contact #contact #formulaire form.wpcf7-form .wpcf7-form-control-wrap.agence select').length) {
			var json_agences = $('.page-template-page-contact #contact #formulaire').attr('data-agences');
			var agences = $.parseJSON(json_agences);

			for (i = 0; i < agences.length; i++) {
				$('.page-template-page-contact #contact #formulaire form.wpcf7-form .wpcf7-form-control-wrap.agence select').append('<option value="' + agences[i]['e'] + '">' + agences[i]['a'] + '</option>');
				$('.page-template-page-contact #contact #formulaire form.wpcf7-form .wpcf7-form-control-wrap.agence .select-items').append('<div>' + agences[i]['a'] + '</div>');
			}

			$('.page-template-page-contact #contact #formulaire form.wpcf7-form .wpcf7-form-control-wrap.agence .select-items div').on('click', function () {
				$('.page-template-page-contact #contact #formulaire form.wpcf7-form .wpcf7-form-control-wrap.agence .select-selected').html($(this).text());
				$('.page-template-page-contact #contact #formulaire form.wpcf7-form .wpcf7-form-control-wrap.agence select').prop('selectedIndex', ($(this).index() + 1));
			});
		}

		/* Script afficher les champs entreprise en fonction du choix "particulier" ou "entreprise" sur la page "Contact" */
		if ($('#formulaire form.wpcf7-form .wpcf7-form-control-wrap.user_type').length) {
			$('#formulaire form.wpcf7-form .wpcf7-form-control-wrap.user_type input[name="user_type"]').on('change', function () {

				$('#formulaire form.wpcf7-form .wpcf7-form-control-wrap.user_type input[name="user_type"]').removeAttr('checked');
				$(this).attr('checked', true);
				$(this).is(":checked");

				if ($(this).val() == 'Professionnel') {
					$('#formulaire form.wpcf7-form .cols .entreprise').each(function () {
						$(this).addClass('active');
					});
				} else {
					$('#formulaire form.wpcf7-form .cols .entreprise').each(function () {
						$(this).removeClass('active');
					});
				}
			});
		}
	}

	/* ==========================================================================
	   SINGLE PRODUCT
	
	   Manager pour les differentes actions liees a une fiche produit
	   ========================================================================== */

	function singleProductOptions() {

		/* Affiche le sous menu drop down quand on est sur une fiche produit */
		$('#displayCategories').on('click', function () {
			$(this).toggleClass('active');
			$('#navigationSingleCategories').slideToggle();
		});

		/* Change le nom de la couleur du produit au clic */
		if ($('form.variations_form table.variations ul.color-variable-wrapper').length) {
			$('form.variations_form table.variations ul li.color-variable-item span.variable-item-span-color').on('click', function () {
				var colorName = $(this).parent().attr('title');

				$(this).closest('table.variations').find('tr td.label label[for="pa_couleur"]').html('Couleur');

				// $('form.variations_form table.variations tr td.label label[for="pa_couleur"]').html('Couleur - '+colorName);
			});
		}

		/* Trigger l'event "change" pour les menus deroulants des variantes de produits ( tu sais le truc ou je me suis enerve pour rien :wink: )*/
		if ($('form.variations_form.cart table.variations tr td .select-options').length) {
			$('form.variations_form.cart table.variations tr td .select-options .select-items div').on('click', function () {
				var val = $(this).text();

				val = val.toLowerCase();
				val = val.replace(' ', '-');

				// on change la valeur du select pour simuler comme quoi on a clique sur l'option (= variante) que l'on souhaite
				$(this).closest('.select-options').find('select option[value="' + val + '"]').is(':selected');
				$(this).closest('.select-options').find('select option[value="' + val + '"]').prop('selected', true);

				// on trigger le changement de variante
				$(this).closest('.select-options').find('select').trigger('change');
			});
		}

		/* Recharge la page si on souhaite reinitialiser les options sur une page categorie produit (exemple : Apple Watch Series 5) */
		$('a.reset_variations').on('click', function (e) {
			e.preventDefault;
			location.reload();
		});
	}

	/* Affiche la couleur selectionnee de la variante de produit */
	function addProductColorToLabel() {
		if ($('form.variations_form table.variations ul.color-variable-wrapper').length) {
			if ($('form.variations_form table.variations ul li.color-variable-item.selected span.variable-item-span-color').length && $('form.variations_form table.variations tr td.label label[for="pa_couleur"]').length) {
				var colorName = $('form.variations_form table.variations ul li.color-variable-item.selected span.variable-item-span-color').parent().attr('title');
				$('form.variations_form table.variations tr td.label label[for="pa_couleur"]').html('Couleur');
			}
		}
	}

	function popupDisplayer() {

		var best_sellers = '';

		// Affiche la popup de confirmation d'ajout au panier
		// if ($('#added_to_cart_confirm').length && $('main .woocommerce-notices-wrapper .woocommerce-message.woocommerce-message').length) {
		if ($('#added_to_cart_confirm').length) {

			if ($('#best-sellers').length) {
				$('#best-sellers').css('display', '');
				best_sellers = $('#best-sellers').clone();
				$('#best-sellers').remove();
			}

			$('main .woocommerce-notices-wrapper .woocommerce-message.woocommerce-message').css('display', 'none');

			var content = '';
			var product_detail = '';

			// on recupere les informations du produit ajoute au panier
			if ($('body').hasClass('single-product')) {
				// si on est sur une page produit (= accessoire)
				content = $('main .woocommerce-notices-wrapper .woocommerce-message.woocommerce-message');
				content.find('a.button.wc-forward').remove();
				product_detail = content.html();
			} else if ($('#heading-intro-famille h2').length) {
				// si on est sur une page categorie (= iMac)
				content = $('#heading-intro-famille h2').html();
				product_detail = '«' + content + '» a été ajouté à votre panier.';
			}

			var new_url = window.location.href.split('?');

			// on ajoute le contenu a la popup
			$('#added_to_cart_confirm').append('<div id="added_to_cart_ttip" class="wrapper">\n\
												<div class="cols">\n\
													<div class="col_full">'+ product_detail + '</div>\n\
													<div class="col_1_2">\n\
														<a href="'+ new_url[0] + '" class="btn noscroll" data-text="Continuer mes achats"><span>Continuer mes achats</span></a>\n\
													</div>\n\
													<div class="col_1_2">\n\
														<a href="'+ $('header #asider .wrapper nav ul#compte li.caddie a').attr('href') + '" class="btn" data-text="Voir mon panier"><span>Voir mon panier</span></a>\n\
													</div>\n\
												</div>\n\
												'+ best_sellers[0].outerHTML + '\n\
											</div>');

			// on affiche la popup
			$('#added_to_cart_confirm').addClass('display');
		}

		// Affiche la popup de confirmation d'inscription a un evenement apres avoir envoye le formulaire
		if ($('.single-evenements #inscription').length) {

			var currentUrl = window.location.href;

			if (currentUrl.indexOf('#wpcf7') != -1) {

				if (cstm_permalink === undefined || cstm_permalink === null || cstm_permalink_txt === undefined || cstm_permalink_txt === null) {
					var cstm_permalink_ctn = '';
					var col_lgth = 'full';
				} else {

					var col_lgth = '1_2';
					var cstm_permalink_ctn = '<div class="col_1_2">\n\
											<a href="'+ cstm_permalink + '" class="btn noscroll" data-text="' + cstm_permalink_txt + '"><span>' + cstm_permalink_txt + '</span></a>\n\
										</div>';
				}

				$('#evt_registration_confirm').append('<div id="evt_registration_ttip" class="wrapper">\n\
														<div class="cols">\n\
															<div class="col_full"><p>Merci, votre inscription à l\'événement <strong>'+ inscription_evt_evt + '</strong> à l\'agence ' + inscription_evt_agence + ', le ' + inscription_evt_date + ' pour ' + inscription_evt_nb_participants + ' personne(s) a bien été prise en compte !</p></div>\n\
															<div class="col_'+ col_lgth + '">\n\
																<a href="'+ permalink + '" class="btn" data-text="Revenir à l\'accueil"><span>Revenir à l\'accueil</span></a>\n\
															</div>\n\
															'+ cstm_permalink_ctn + '\n\
														</div>\n\
													</div>');

				$('#evt_registration_confirm').addClass('display');
			}
		}

		// Affiche la popup de confirmation d'envoi de l'email depuis la page contact
		if ($('.page-template-page-contact #formulaire').length) {

			if ($('#actualites').length) {
				$('#actualites').css('display', '');
				best_sellers = $('#actualites').clone();
				$('#actualites').remove();
			}

			var currentUrl = window.location.href;

			if (currentUrl.indexOf('#wpcf7') != -1) {
				$('#cf_sent_confirm').append('<div id="cf_sent_ttip" class="wrapper">\n\
												<div class="cols">\n\
													<div class="col_full">\n\
														<p>Merci, votre message vient de nous être envoyé !</p>\n\
														<p>Nous vous répondrons dans les meilleurs délais.</p>\n\
													</div>\n\
													<div class="col_full center">\n\
														<a href="'+ permalink + '" class="btn" data-text="Revenir à l\'accueil"><span>Revenir à l\'accueil</span></a>\n\
													</div>\n\
												</div>\n\
												'+ best_sellers[0].outerHTML + '\n\
											</div>');

				$('#cf_sent_confirm').addClass('display');
			}
		}

		// Affiche l'aside shopping cart
		$('header #asider .wrapper nav ul#compte li.caddie a').on('click', function (e) {
			if ($(window).width() > 1019) {
				e.preventDefault();
				e.stopPropagation();
				$('#aside_sc').toggleClass('open');
			} else {
				$('#aside_sc').removeClass('open');
			}
		});

		$('header #asider .wrapper nav #aside_sc ul li a#continue_buy').on('click', function (e) {
			if ($('#aside_sc').hasClass('open')) {
				$('#aside_sc').removeClass('open');
			}
		});
	}

	/* ==========================================================================
	   EVENEMENTS
	
	   Manager pour afficher les elements en fonction des choix et options selectionnees dans les etapes d'inscription a un evenement
	   ========================================================================== */
	function evenementsInscriptionManager() {
		if ($('.single-evenements #inscription').length) {
			var data_evenement = $('.single-evenements #inscription').attr('data-evenement');

			// on verifie qu'il ai bien le json des valeurs
			if (typeof data_evenement !== typeof undefined && data_evenement !== false) {

				$('.single-evenements #inscription #steps #step4 form.wpcf7-form input#evt').val($('.single-evenements #inscription').attr('data-evt'));

				var datas = $.parseJSON(data_evenement);

				/* 1 - lorsque l'on clique sur une agence */
				$('.single-evenements #inscription #steps #step1 .agence').on('click', function () {

					$('.single-evenements #inscription #steps #step1 .agence').removeClass('selected');
					$(this).addClass('selected');

					var agence = $(this).find('h4').text();

					// on ajoute l'agence dans le formulaire
					$('.single-evenements #inscription #steps #step4 form.wpcf7-form input#evt_agence').val(agence);

					// on recupere les donnees de l'agence (dates, heures, nombre de places)
					var agence_data = datas[agence];

					// on clean les option des select date et heure
					$('.single-evenements #inscription #steps #step2 #dates_selector select#date_selection').html('');
					$('.single-evenements #inscription #steps #step2 #dates_selector select#date_selection').html('<option value="">Date</option>');
					$('.single-evenements #inscription #steps #step2 #dates_selector .select-items').html('');
					$('.single-evenements #inscription #steps #step2 #dates_selector .select-selected').html('Date');

					$('.single-evenements #inscription #steps #step2 #hours_selector select#hour_selection').html('');
					$('.single-evenements #inscription #steps #step2 #hours_selector select#hour_selection').html('<option value="">Horaire</option>');
					$('.single-evenements #inscription #steps #step2 #hours_selector .select-items').html('');
					$('.single-evenements #inscription #steps #step2 #hours_selector .select-selected').html('Horaire');

					// on va charger les dates
					for (var key in agence_data['dates']) {

						var date = key.replace(/(\d{4})(\d{2})(\d{2})/g, '$3/$2/$1'); // source: https://stackoverflow.com/a/36638153

						// on calcule le nombre de places restantes pour desactiver ou non la/les dates ou les reservations sont completes
						var nb_places = 0;
						var nb_places_reservees = 0;

						for (var k in agence_data['dates'][key]['creneaux']) {
							nb_places += parseInt(agence_data['dates'][key]['creneaux'][k]['nb_places']);
							nb_places_reservees += parseInt(agence_data['dates'][key]['creneaux'][k]['nb_places_reservees']);
						}

						// on ajoute chaque date au select de choix de date (dans l'etape 2)
						$('.single-evenements #inscription #steps #step2 #dates_selector select#date_selection').append('<option value="' + key + '" ' + (((nb_places - nb_places_reservees) > 0) ? '' : 'disabled') + '>' + date + '</option>');

						//on ajoute egalement l'option dans le custom select
						if (((nb_places - nb_places_reservees) > 0)) {
							$('.single-evenements #inscription #steps #step2 #dates_selector .select-items').append('<div data-val="' + key + '">' + date + '</div>');
						}
					}

					$('.single-evenements #inscription #steps #step2').addClass('active');
					$('.single-evenements #inscription #steps #step2 div.a').slideDown();
				});

				/* 2 - lorsque l'on clique sur une date */
				// $('.single-evenements #inscription #steps #step2 #dates_selector select#date_selection').on('change', function() {
				$(document).on('click', '.single-evenements #inscription #steps #step2 #dates_selector .select-items div', function () {
					// var selected_date = $(this).val();
					var selected_date = $(this).attr('data-val');

					$('.single-evenements #inscription #steps #step2 #dates_selector .select-selected').html($(this).text());
					$('.single-evenements #inscription #steps #step2 #dates_selector .select-selected').attr('data-val', selected_date);

					var agence = $('.single-evenements #inscription #steps #step1 .agence.selected h4').text();

					// on ajoute la date dans le formulaire
					$('.single-evenements #inscription #steps #step4 form.wpcf7-form input#evt_date').val(selected_date);

					// on recupere les donnees de l'agence (dates, heures, nombre de places)
					var agence_data = datas[agence];

					// on clean les option du select heure
					$('.single-evenements #inscription #steps #step2 #hours_selector select#hour_selection').html('');
					$('.single-evenements #inscription #steps #step2 #hours_selector select#hour_selection').html('<option value="">Horaire</option>');
					$('.single-evenements #inscription #steps #step2 #hours_selector .select-items').html('');
					$('.single-evenements #inscription #steps #step2 #hours_selector .select-selected').html('Horaire');

					// si on a plusieurs creneaux renseignes
					if (agence_data['dates'][selected_date]['creneaux'].length > 1) {
						// on va charger les creneaux de la date selectionnee
						for (var key in agence_data['dates'][selected_date]['creneaux']) {

							var formatedDate = agence_data['dates'][selected_date]['creneaux'][key]['creneau'];

							formatedDate = formatedDate.charAt(0).toUpperCase() + formatedDate.slice(1);

							if (agence_data['dates'][selected_date]['type'] === 'heures') {
								formatedDate = formatedDate.replace('_', 'h00 - ') + 'h00';
							}

							$('.single-evenements #inscription #steps #step2 #hours_selector select#hour_selection').append('<option value="' + agence_data['dates'][selected_date]['creneaux'][key]['creneau'] + '" ' + (((agence_data['dates'][selected_date]['creneaux'][key]['nb_places'] - agence_data['dates'][selected_date]['creneaux'][key]['nb_places_reservees']) > 0) ? '' : 'disabled') + '>' + formatedDate + '</option>');

							//on ajoute egalement l'option dans le custom select
							if (((agence_data['dates'][selected_date]['creneaux'][key]['nb_places'] - agence_data['dates'][selected_date]['creneaux'][key]['nb_places_reservees']) > 0)) {
								$('.single-evenements #inscription #steps #step2 #hours_selector .select-items').append('<div data-val="' + agence_data['dates'][selected_date]['creneaux'][key]['creneau'] + '">' + formatedDate + '</div>');
							}
						}
					} else { // si il n'y a qu'un seul creneau

						var formatedDate = agence_data['dates'][selected_date]['creneau'][0]['creneau'];

						formatedDate = formatedDate.charAt(0).toUpperCase() + formatedDate.slice(1);

						if (agence_data['dates'][selected_date]['type'] === 'heures') {
							formatedDate = formatedDate.replace('_', 'h00 - ') + 'h00';
						}

						$('.single-evenements #inscription #steps #step2 #hours_selector select#hour_selection').append('<option value="' + agence_data['dates'][selected_date]['creneaux'][0]['creneau'] + '" ' + (((agence_data['dates'][selected_date]['creneaux'][0]['nb_places'] - agence_data['dates'][selected_date]['creneaux'][0]['nb_places_reservees']) > 0) ? '' : 'disabled') + '>' + formatedDate + '</option>');

						//on ajoute egalement l'option dans le custom select
						if (((agence_data['dates'][selected_date]['creneaux'][key]['nb_places'] - agence_data['dates'][selected_date]['creneaux'][key]['nb_places_reservees']) > 0)) {
							$('.single-evenements #inscription #steps #step2 #hours_selector .select-items').append('<div data-val="' + agence_data['dates'][selected_date]['creneaux'][key]['creneau'] + '">' + formatedDate + '</div>');
						}
					}
				});

				/* 3 - lorsqu'on selectionne son creneau (clique sur heure ou demi-journee) */
				// $('.single-evenements #inscription #steps #step2 #hours_selector select#hour_selection').on('change', function() {
				$(document).on('click', '.single-evenements #inscription #steps #step2 #hours_selector .select-items div', function () {
					// var selected_hour = $('.single-evenements #inscription #steps #step2 #hours_selector select#hour_selection option').filter(":selected").val();
					// var selected_date = $('.single-evenements #inscription #steps #step2 #dates_selector select#date_selection option').filter(":selected").val();

					var selected_hour = $(this).attr('data-val');
					var selected_date = $('.single-evenements #inscription #steps #step2 #dates_selector .select-selected').attr('data-val');

					$('.single-evenements #inscription #steps #step2 #hours_selector .select-selected').html($(this).text());

					var agence = $('.single-evenements #inscription #steps #step1 .agence.selected h4').text();

					// on ajoute la date dans le formulaire
					$('.single-evenements #inscription #steps #step4 form.wpcf7-form input#evt_heure').val(selected_hour);

					// on recupere les donnees de l'agence (dates, heures, nombre de places)
					var agence_data = datas[agence];

					// on clean le nb de participants
					$('.single-evenements #inscription #steps #step3 #nb_participants_selector #nb_participants_selection').html('');
					$('.single-evenements #inscription #steps #step3 #nb_participants_selector #nb_participants_selection').html('<option value="">Participants</option>');
					$('.single-evenements #inscription #steps #step3 #nb_participants_selector .select-items').html('');
					$('.single-evenements #inscription #steps #step3 #nb_participants_selector .select-selected').html('Participants');

					// on va afficher les options possibles de places a reserver (dans l'etape 3)
					if (agence_data['dates'][selected_date]['creneaux'].length > 1) {
						// on va charger les creneaux de la date selectionnee
						for (var key in agence_data['dates'][selected_date]['creneaux']) {
							// si parmis les creneaux celui qui est selectionne correspond
							if (agence_data['dates'][selected_date]['creneaux'][key]['creneau'] === selected_hour) {
								// on affiche la liste de places disponibles a la reservation pour ce creneau (dans le select dans l'etape 3)
								for (i = 1; i <= (agence_data['dates'][selected_date]['creneaux'][key]['nb_places'] - agence_data['dates'][selected_date]['creneaux'][key]['nb_places_reservees']); i++) {
									$('.single-evenements #inscription #steps #step3 #nb_participants_selector #nb_participants_selection').append('<option value=' + i + '>' + i + '</option>');

									//on ajoute egalement l'option dans le custom select
									$('.single-evenements #inscription #steps #step3 #nb_participants_selector .select-items').append('<div data-val="' + i + '">' + i + '</div>');
								}
							}
						}
					} else {

						// on affiche la liste de places disponibles a la reservation pour ce creneau (dans le select dans l'etape 3)
						for (i = 1; i <= (agence_data['dates'][selected_date]['creneaux'][0]['nb_places'] - agence_data['dates'][selected_date]['creneaux'][0]['nb_places_reservees']); i++) {
							$('.single-evenements #inscription #steps #step3 #nb_participants_selector #nb_participants_selection').append('<option value=' + i + '>' + i + '</option>');

							//on ajoute egalement l'option dans le custom select
							$('.single-evenements #inscription #steps #step3 #nb_participants_selector .select-items').append('<div data-val="' + i + '">' + i + '</div>');
						}
					}

					$('.single-evenements #inscription #steps #step3').addClass('active');
					$('.single-evenements #inscription #steps #step3 div.a').slideDown();
				});

				/* 4 - lorsqu'on selectionne le nombre de participants */
				// $('.single-evenements #inscription #steps #step3 #nb_participants_selector select#nb_participants_selection').on('change', function() {
				$(document).on('click', '.single-evenements #inscription #steps #step3 #nb_participants_selector .select-items div', function () {
					// var nb_participants = $(this).val();
					var nb_participants = $(this).attr('data-val');

					$('.single-evenements #inscription #steps #step3 #nb_participants_selector .select-selected').html(nb_participants);

					// on ajoute la date dans le formulaire
					$('.single-evenements #inscription #steps #step4 form.wpcf7-form input#evt_nb_participants').val(nb_participants);

					$('.single-evenements #inscription #steps #step4 form.wpcf7-form #participants #ps').html('');

					// on cree le nombre de champs pour chaque participants
					if (nb_participants > 1) {
						for (var i = 2; i <= nb_participants; i++) {
							$('.single-evenements #inscription #steps #step4 form.wpcf7-form #participants #ps').append('<div id="p' + i + '" class="cols participant">\n\
																															<div class="col_full"><div class="field"><span class="txt-label"><strong>Participant '+ i + '</strong></span></div></div>\n\
																															<div class="col_1_2">\n\
																																<div class="field">\n\
																																	<span class="txt-label">Nom *</span>\n\
																																	<span class="wpcf7-form-control-wrap nom_p'+ i + '"><input type="text" name="nom_p[' + i + ']" value="" size="40" class="wpcf7-form-control wpcf7-text wpcf7-validates-as-required" aria-required="true" aria-invalid="false" required="required"></span>\n\
																																</div>\n\
																															</div>\n\
																															<div class="col_1_2">\n\
																																<div class="field">\n\
																																	<span class="txt-label">Prénom *</span>\n\
																																	<span class="wpcf7-form-control-wrap prenom_p'+ i + '"><input type="text" name="prenom_p[' + i + ']" value="" size="40" class="wpcf7-form-control wpcf7-text wpcf7-validates-as-required" aria-required="true" aria-invalid="false" required="required"></span>\n\
																																</div>\n\
																															</div>\n\
																															<div class="col_1_2">\n\
																																<div class="field">\n\
																																	<span class="txt-label">Email *</span>\n\
																																	<span class="wpcf7-form-control-wrap email_p'+ i + '"><input type="email" name="email_p[' + i + ']" value="" size="40" class="wpcf7-form-control wpcf7-email wpcf7-validates-as-required wpcf7-validates-as-email" aria-required="true" aria-invalid="false" required="required"></span>\n\
																																</div>\n\
																															</div>\n\
																															<div class="col_1_2">\n\
																																<div class="field">\n\
																																	<span class="txt-label">Téléphone *</span>\n\
																																	<span class="wpcf7-form-control-wrap telephone_p'+ i + '"><input type="tel" name="telephone_p[' + i + ']" value="" size="40" class="wpcf7-form-control wpcf7-tel wpcf7-validates-as-required wpcf7-validates-as-tel" aria-required="true" aria-invalid="false" required="required"></span>\n\
																																</div>\n\
																															</div>\n\
																														</div>')
						}
					}

					$('.single-evenements #inscription #steps #step4').addClass('active');
					$('.single-evenements #inscription #steps #step4 div.a').slideDown();
				});

				/* 5 - on verifie si tous les champs "obligatoires" sont renseignes (on effectue une verification ici afin de ne pas avoir a dupliquer le formulaires (pro et particulier) mais egalement pour les champs dynamiques participants) */
				$(".single-evenements #inscription form.wpcf7-form .wpcf7-submit").on('click', function (e) {
					e.preventDefault();

					$('.single-evenements #inscription form.wpcf7-form span[role="alert"]').remove();

					// on supprime les champs
					$('.single-evenements #inscription form.wpcf7-form input[name="entreprise_nom"] + span.wpcf7-not-valid-tip').remove();
					$('.single-evenements #inscription form.wpcf7-form input[name="entreprise_adresse"] + span.wpcf7-not-valid-tip').remove();
					$('.single-evenements #inscription form.wpcf7-form input[name="telephone"] + span.wpcf7-not-valid-tip').remove();

					var submitForm = true;

					// si l'inscrit est un professionnel
					if ($('.single-evenements #inscription form.wpcf7-form input[name="user_type"]:checked').val() == 'Professionnel') {

						// alors on verifie que le nom et l'adresse de l'entreprise est bien renseignee
						if (!$('.single-evenements #inscription form.wpcf7-form input[name="entreprise_nom"]').val()) {
							$('.single-evenements #inscription form.wpcf7-form input[name="entreprise_nom"]').after('<span role="alert" class="wpcf7-not-valid-tip">Un champ nécessaire n’a pas été rempli.</span>');
							submitForm = false;
						}
						if (!$('.single-evenements #inscription form.wpcf7-form input[name="entreprise_adresse"]').val()) {
							$('.single-evenements #inscription form.wpcf7-form input[name="entreprise_adresse"]').after('<span role="alert" class="wpcf7-not-valid-tip">Un champ nécessaire n’a pas été rempli.</span>');
							submitForm = false;
						}
					}

					// on verifie le numero de telephone
					// if ($('.single-evenements #inscription form.wpcf7-form input[name="telephone"]').val().length !== 10) {
					// 	$('.single-evenements #inscription form.wpcf7-form input[name="telephone"]').after('<span role="alert" class="wpcf7-not-valid-tip">Veuillez renseigner un numéro valide.</span>');
					// 	submitForm = false;
					// }
					if (!validatePhoneNumber($('.single-evenements #inscription form.wpcf7-form input[name="telephone"]'))) {
						submitForm = false;
						return;
					}
					if (!validateEmail($('.single-evenements #inscription form.wpcf7-form input[name="email"]'))) {
						submitForm = false;
						return;
					}

					$('.single-evenements #inscription form.wpcf7-form input.wpcf7-validates-as-required').each(function () {
						if (!$(this).val()) {
							$(this).after('<span role="alert" class="wpcf7-not-valid-tip">Champ obligatoire.</span>');
							submitForm = false;
							return;
						}
					});
					if (!$('.single-evenements #inscription form.wpcf7-form #rgpd label input[name="rgpd-compliance[]"]').is(":checked")) {
						$('.single-evenements #inscription form.wpcf7-form #rgpd label').append('<span role="alert" class="wpcf7-not-valid-tip">Champ obligatoire.</span>');
						submitForm = false;
						return;
					}

					if (submitForm == true) {
						$(".single-evenements #inscription form.wpcf7-form").submit();
					}
				});

			}
		}
	}

	/* Effectue un rechargement de la page du panier lorsque le panier est vide pour eviter une page blanche */
	function redirectIfCartIsEmpty() {
		if ($('section#wc-dashboard .woocommerce .woocommerce-cart-form table.shop_table tr td.product-remove a').length) {
			$(document).on('click', 'section#wc-dashboard .woocommerce .woocommerce-cart-form table.shop_table tr td.product-remove a', function () {
				var items = $('section#wc-dashboard .woocommerce .woocommerce-cart-form table.shop_table tr.cart_item').length;

				needRefreshIfCartIsEmpty(items);
			});
		}
	}

	function needRefreshIfCartIsEmpty(items) {
		if (items - 1 === 0) {
			setTimeout(function () {
				if ($('form.woocommerce-cart-form').hasClass('processing')) {
					needRefreshIfCartIsEmpty(items);
				} else {
					location.reload();
					return;
				}
			}, 800);
		}
	}

	/* Effectue une recherche des produits a conseiller en ajax via l'API REST dans la barre de recherche */
	function AutoCompleteSearch() {

		/* Trigger de l'auto-complete apres avoir termine d'ecrire
		 * source: https://stackoverflow.com/a/5926782
		 */
		var typingTimer; //timer identifier

		//on keyup, start the countdown
		// $('#search-form form input.search-field, #results-search-form form input.search-field').on('keyup', function(){
		// 	$('.autocomplete-results ul').html('');

		//     clearTimeout(typingTimer);

		//     var input = $(this);

		//     // on va faire l'auto search
		//     if (input.val() && input.val().length > 3) {
		//         typingTimer = setTimeout(function() {
		//         	$.ajax({
		// 				url: ajax_url,
		// 				type: 'post',
		// 				data: {
		// 			        'action': 'AutoCompleteSearch',
		// 			        'keywords': input.val()
		// 				},
		// 				success: function( result ) {
		// 					var products = $.parseJSON(result);

		// 					$('#search-form').css('overflow','visible'); /* on met l'overflow visible pour afficher les suggestions */

		// 					$('.autocomplete-results').focus();

		// 					for(i = 0; i < products.length; i++) {
		// 						input.closest('.search-form').next('.autocomplete-results').find('ul').append('<li>'+products[i].post_title+'</li>');
		// 					}
		// 				}
		// 			});
		//         }, 500);
		//     }
		// });

		function delay(callback, ms) {
			var timer = 0;
			return function () {
				var context = this, args = arguments;
				clearTimeout(timer);
				timer = setTimeout(function () {
					callback.apply(context, args);
				}, ms || 0);
			};
		}

		var processing = false;

		$('#search-form form input.search-field, #results-search-form form input.search-field').on('keyup', delay(function (e) {
			e.stopPropagation();

			$('.autocomplete-results ul').html('');

			var input = $(this);

			// on va faire l'auto search
			if (input.val() && input.val().length > 3 && !$('#search-form form input.search-field, #results-search-form form input.search-field').hasClass('processing')) {

				if (!$('#search-form form input.search-field, #results-search-form form input.search-field').hasClass('processing')) {
					$('#search-form form input.search-field, #results-search-form form input.search-field').addClass('processing');
				}

				$.ajax({
					url: ajax_url,
					type: 'post',
					data: {
						'action': 'AutoCompleteSearch',
						'keywords': input.val()
					},
					success: function (result) {
						var products = $.parseJSON(result);

						$('#search-form').css('overflow', 'visible'); /* on met l'overflow visible pour afficher les suggestions */

						$('.autocomplete-results').focus();

						for (i = 0; i < products.length; i++) {
							input.closest('.search-form').next('.autocomplete-results').find('ul').append('<li>' + products[i].post_title + '</li>');
						}
					}
				});
			}
			setTimeout(function () {
				$('#search-form form input.search-field, #results-search-form form input.search-field').removeClass('processing');
			}, 1000);
		}, 500));

		// lorsqu'on clique sur un resultat
		$(document).on('click', '.autocomplete-results ul li', function () {

			var autosearch = $(this).html();

			$('#search-form').css('overflow', 'hidden'); /* on supprime l'overflow visible pour cacher les suggestions et que le rendu de la barre soit "smooth" */

			$(this).closest('.autocomplete-results').parent().find('form.search-form input.search-field').val(autosearch);

			$(this).closest('.autocomplete-results').parent().find('form.search-form').submit();
		});
	}

	/* Effectue les verifications et actions lors de la reservation sur le formulaire (si l'utilisateur n'est pas inscrit) */
	function reserverInscriptionOptions() {

		if ($('section#wc-dashboard .wrapper .cols .col_full .woocommerce form.checkout').length) {

			/* Permet de valider ou non les donnees renseignees dans un champs input[type=tel] */
			$(document).on('focusout, keyup', 'section#wc-dashboard .wrapper .cols .col_full .woocommerce form.checkout #billing_phone', function () {

				$('section#wc-dashboard .wrapper .cols .col_full .woocommerce form.checkout #billing_phone_field span.wpcf7-not-valid-tip').remove();
				$('section#wc-dashboard .wrapper .cols .col_full .woocommerce form.checkout #place_order').show();

				if ($(this).val().length !== 10) {
					$('section#wc-dashboard .wrapper .cols .col_full .woocommerce form.checkout #billing_phone_field').append('<span role="alert" class="wpcf7-not-valid-tip">Veuillez renseigner un numéro valide.</span>');
					$('section#wc-dashboard .wrapper .cols .col_full .woocommerce form.checkout #place_order').hide();
				}
			});

			/* Permet de valider ou non les donnees renseignees dans un champs input[type=email] */
			$(document).on('focusout, keyup', 'section#wc-dashboard .wrapper .cols .col_full .woocommerce form.checkout #billing_email', function () {

				var pattern = new RegExp(/^(("[\w-+\s]+")|([\w-+]+(?:\.[\w-+]+)*)|("[\w-+\s]+")([\w-+]+(?:\.[\w-+]+)*))(@((?:[\w-+]+\.)*\w[\w-+]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][\d]\.|1[\d]{2}\.|[\d]{1,2}\.))((25[0-5]|2[0-4][\d]|1[\d]{2}|[\d]{1,2})\.){2}(25[0-5]|2[0-4][\d]|1[\d]{2}|[\d]{1,2})\]?$)/i);

				$('section#wc-dashboard .wrapper .cols .col_full .woocommerce form.checkout #billing_email_field span.wpcf7-not-valid-tip').remove();
				$('section#wc-dashboard .wrapper .cols .col_full .woocommerce form.checkout #place_order').show();

				if (!pattern.test($(this).val())) {
					$('section#wc-dashboard .wrapper .cols .col_full .woocommerce form.checkout #billing_email_field').append('<span role="alert" class="wpcf7-not-valid-tip">Veuillez renseigner une adresse email valide.</span>');
					$('section#wc-dashboard .wrapper .cols .col_full .woocommerce form.checkout #place_order').hide();
				}
			});
		}
	}

	/* Permet de valider ou non les donnees renseignees dans un champs input[type=tel] */
	function validatePhoneNumber(fieldtocheck) {
		// on verifie le numero de telephone
		if ((fieldtocheck.val().length == 10) && (/^\d+$/.test(fieldtocheck.val()))) {
			$('#invalid-telephone').remove();
			return true;
		} else {
			if (!$('#invalid-telephone').length) {
				fieldtocheck.after('<span id="invalid-telephone" role="alert" class="wpcf7-not-valid-tip">Veuillez renseigner un numéro valide.</span>');
			}
			return false;
		}
	}

	/**
	 * Permet de valider ou non les donnees renseignees dans un champs input[type=email]
	 * source: https://stackoverflow.com/a/8398463 */
	function validateEmail(fieldtocheck) {
		var pattern = new RegExp(/^(("[\w-+\s]+")|([\w-+]+(?:\.[\w-+]+)*)|("[\w-+\s]+")([\w-+]+(?:\.[\w-+]+)*))(@((?:[\w-+]+\.)*\w[\w-+]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][\d]\.|1[\d]{2}\.|[\d]{1,2}\.))((25[0-5]|2[0-4][\d]|1[\d]{2}|[\d]{1,2})\.){2}(25[0-5]|2[0-4][\d]|1[\d]{2}|[\d]{1,2})\]?$)/i);

		// on verifie le numero de telephone
		if (pattern.test(fieldtocheck.val())) {
			$('#invalid-email').remove();
			return true;
		} else {
			if (!$('#invalid-email').length) {
				fieldtocheck.after('<span id="invalid-email" role="alert" class="wpcf7-not-valid-tip">Veuillez renseigner une adresse email valide.</span>');
			}
			return false;
		}
	}

	// End JQuery
});

// DOM load
document.addEventListener("DOMContentLoaded", function (event) {

	// Debug page load hover effect
	// let header = document.querySelector('.header');
	// setTimeout(() => {
	// 	header.classList.remove('no-hover');
	// }, "100");

	// Accordion
	let accordions = document.querySelectorAll('.accordion');

	function deactivateSiblings() {
		for (const accordion of accordions) {
			accordion.classList.remove('active');
		}
	}

	if (accordions.length > 0) {
		for (let i = 0; i < accordions.length; i++) {
			let accordion = accordions[i];
			let accordionBtn = accordion.querySelector('.accordion__header');
			accordionBtn.addEventListener('click', function () {
				if (accordion.classList.contains('active')) {
					accordion.classList.remove('active');
				} else {
					deactivateSiblings();
					accordion.classList.add('active');
				}
			});
		}
	}

	/* Pro-expertise */
	let expertExists = document.querySelectorAll('.pro-expertise');

	if (typeof (expertExists) != 'undefined' && expertExists != null) {

		let expertsReset = () => {
			expertExists.forEach((el) =>el.classList.remove('active'));
		}

		for (let i=0;i<expertExists.length;i++) {
			let plus = expertExists[i].querySelector('.pro-expertise__plus');
			plus.addEventListener("click", function (el) {
				expertsReset();
				plus.parentNode.parentNode.classList.add('active');
			});
		}

	}



	/* Leaflet */
	let mapExists = document.querySelector('#map');

	if (typeof (mapExists) != 'undefined' && mapExists != null) {

		var lat = 48.312313;
		var lon = -2.077868;

		var map = L.map('map').setView([lat, lon], 7);

		L.tileLayer('https://server.arcgisonline.com/ArcGIS/rest/services/Canvas/World_Light_Gray_Base/MapServer/tile/{z}/{y}/{x}', {
			maxZoom: 16,
			attribution: ''
		}).addTo(map);

		var pin_icon = document.querySelector('.js-icon').innerHTML;
		var pin_size = [26, 40];
		var pin_anchor = [16, 40];

		var icon = L.icon({
			iconUrl: pin_icon,
			shadowUrl: '',
			iconSize: pin_size, // size of the icon
			shadowSize: [0, 0], // size of the shadow
			iconAnchor: pin_anchor // point of the icon which will correspond to marker's location
		});

		function addMarker(title, lat, lng) {
			var p = L.marker([lat, lng], { icon: icon });
			p.title = title;
			p.alt = title;
			p.bindPopup(title);
			p.addTo(map);
		}

		if (accordions.length > 0) {
			for (let i = 0; i < accordions.length; i++) {
				let accordion = accordions[i];
				let accordionTitle = accordion.querySelector('.accordion__title').innerHTML;
				let accordionLat = accordion.getAttribute('data-lat');
				let accordionLng = accordion.getAttribute('data-lng');
				// Init n' push
				addMarker(accordionTitle, accordionLat, accordionLng);
				// Click !
				let accordionBtn = accordion.querySelector('.accordion__header');
				accordionBtn.addEventListener('click', function (e) {
					if (accordion.classList.contains('active')) {
						console.log('Latitude ' + accordion.getAttribute('data-lat'));
						console.log('Longitude ' + accordion.getAttribute('data-lng'));
						map.flyTo([accordionLat, accordionLng], 9, {
							animate: true,
							duration: 1.5
						});
					}
				});
			}
		}

	}

	/* SplideJS - Vanilla JS scripts */
	let sliderExists = document.querySelector('.splide--slider');
	let carouselExists = document.querySelector('.splide--carousel');
	let carouselProductsExists = document.querySelector('.splide--carousel-products');
	let proQuotesExists = document.querySelector('.splide--pro-quotes');
	let proCarouselExists = document.querySelector('.splide--pro-carousel');
	let proCertifExists = document.querySelector('.splide--pro-certifications');
	let proServicesExists = document.querySelector('.splide--pro-services');
	let proPostsExists = document.querySelector('.splide--pro-posts');
	let latestPostsExists = document.querySelector('.splide--latest-posts');

	if (typeof (sliderExists) != 'undefined' && sliderExists != null) {
		// Carousel realisations
		let sliderHome = new Splide(sliderExists, {
			type: 'loop',
			rewind: true,
			arrows: true,
			pagination: false,
			perPage: 1,
			perMove: 1,
			focus: 0,
			autoplay: true,
			speed: 1000,
			interval: 3000,
			snap: true,
			easing: 'cubic-bezier(0.165, 0.84, 0.44, 1)',
		});

		sliderHome.mount();
	}

	if (typeof (carouselExists) != 'undefined' && carouselExists != null) {
		// Carousel
		let carouselLaunch = new Splide(carouselExists, {
			type: 'loop',
			perPage: 1,
			focus: 'center',
			autoplay: true,
			interval: 8000,
			flickMaxPages: 3,
			updateOnMove: true,
			pagination: false,
			easing: 'cubic-bezier(0.165, 0.84, 0.44, 1)',
			mediaQuery: "min",
			gap: '4vw',
			breakpoints: {
				768: {
					perPage: 3,
				}
			}
		});

		carouselLaunch.mount();
	}

	if (typeof (carouselProductsExists) != 'undefined' && carouselProductsExists != null) {
		// Carousel Produits
		let carouselProductsLaunch = new Splide(carouselProductsExists, {
			type: 'loop',
			perPage: 1,
			focus: 'center',
			autoplay: true,
			interval: 5000,
			flickMaxPages: 3,
			updateOnMove: true,
			pagination: false,
			arrows: true,
			easing: 'cubic-bezier(0.165, 0.84, 0.44, 1)',
			mediaQuery: "min",
			gap: '40px',
			breakpoints: {
				768: {
					perPage: 3,
				}
			}
		});

		carouselProductsLaunch.mount();
	}

	if (typeof (proQuotesExists) != 'undefined' && proQuotesExists != null) {
		// Avis
		let proQuotesLaunch = new Splide(proQuotesExists, {
			type: 'loop',
			perPage: 1,
			focus: 'center',
			autoplay: true,
			interval: 5000,
			flickMaxPages: 3,
			updateOnMove: true,
			pagination: false,
			arrows: false,
			easing: 'cubic-bezier(0.165, 0.84, 0.44, 1)',
			mediaQuery: "min",
			gap: '40px',
			breakpoints: {
				768: {
					perPage: 3,
				}
			}
		});

		proQuotesLaunch.mount();
	}

	if (typeof (proCarouselExists) != 'undefined' && proCarouselExists != null) {
		// Pro Carousel
		let proCarouselLaunch = new Splide(proCarouselExists, {
			type: 'loop',
			arrows: false,
			perPage: 1,
			focus: 'center',
			autoplay: true,
			interval: 0,
			speed: 150000,
			flickMaxPages: 3,
			updateOnMove: true,
			pagination: false,
			easing: 'cubic-bezier(0.165, 0.84, 0.44, 1)',
			mediaQuery: "min",
			gap: '20px',
			breakpoints: {
				768: {
					perPage: 8,
				}
			}
		});

		proCarouselLaunch.mount();
	}

	if (typeof (proCertifExists) != 'undefined' && proCertifExists != null) {
		// Pro Carousel
		let proCertifLaunch = new Splide(proCertifExists, {
			type: 'loop',
			arrows: false,
			perPage: 1,
			focus: 'center',
			autoplay: true,
			interval: 0,
			speed: 150000,
			flickMaxPages: 3,
			updateOnMove: true,
			pagination: false,
			easing: 'cubic-bezier(0.165, 0.84, 0.44, 1)',
			mediaQuery: "min",
			gap: '20px',
			breakpoints: {
				768: {
					perPage: 8,
				}
			}
		});

		proCertifLaunch.mount();
	}

	if (typeof (proServicesExists) != 'undefined' && proServicesExists != null) {
		// Carousel Nos Services
		let proServicesBtn = document.querySelector('.pro-services__btn');
		let proServicesLaunch = new Splide(proServicesExists, {
			type: 'loop',
			arrows: false,
			perPage: 1,
			focus: 'center',
			autoplay: true,
			interval: 3000,
			flickMaxPages: 3,
			updateOnMove: true,
			pagination: false,
			easing: 'cubic-bezier(0.165, 0.84, 0.44, 1)',
			mediaQuery: "min",
			breakpoints: {
				768: {
					perPage: 3,
					focus: 'left',
				}
			}
		});

		//attach events to custom buttons
		proServicesBtn.addEventListener('click', e => {
			proServicesLaunch.go('+1')
		})

		proServicesLaunch.mount();
	}

	if (typeof (proPostsExists) != 'undefined' && proPostsExists != null) {
		// Carousel Articles
		let proPostsBtn = document.querySelector('.pro-posts__btn');
		let proPostsLaunch = new Splide(proPostsExists, {
			type: 'loop',
			arrows: false,
			perPage: 1,
			focus: 'center',
			autoplay: true,
			interval: 3000,
			flickMaxPages: 3,
			updateOnMove: true,
			pagination: false,
			easing: 'cubic-bezier(0.165, 0.84, 0.44, 1)',
			mediaQuery: "min",
			breakpoints: {
				768: {
					perPage: 3,
					focus: 'left',
				}
			}
		});

		//attach events to custom buttons
		proPostsBtn.addEventListener('click', e => {
			proPostsLaunch.go('+1')
		})

		proPostsLaunch.mount();
	}

	if (typeof (latestPostsExists) != 'undefined' && latestPostsExists != null) {
		// Carousel Derniers posts
		let latestPostsBtn = document.querySelector('.latest-posts__btn');
		let latestPostsLaunch = new Splide(latestPostsExists, {
			type: 'loop',
			arrows: false,
			perPage: 1,
			focus: 'center',
			autoplay: true,
			interval: 3000,
			flickMaxPages: 3,
			updateOnMove: true,
			pagination: false,
			easing: 'cubic-bezier(0.165, 0.84, 0.44, 1)',
			mediaQuery: "min",
			gap: '10px',
			breakpoints: {
				768: {
					perPage: 3,
					focus: 'left',
				}
			}
		});

		//attach events to custom buttons
		latestPostsBtn.addEventListener('click', e => {
			latestPostsLaunch.go('+1')
		})

		latestPostsLaunch.mount();
	}

	// Steps
	// https://labex.io/fr/tutorials/scroll-progress-bar-35236
	let steps = document.querySelector('.steps');

	if (typeof (steps) != 'undefined' && steps != null) {

		let stepsTopPos = steps.offsetTop;
		const progressBar = document.querySelector(".steps__marker");
		// const totalHeight = document.documentElement.scrollHeight - window.innerHeight;
		let totalHeight = stepsTopPos + steps.offsetHeight;

		// Function to update the progress bar
		const updateProgressBar = () => {
			let diff = window.scrollY - stepsTopPos;
			const scrollPosition = window.scrollY + (window.innerHeight / 2);
			if (scrollPosition > stepsTopPos && (diff + (window.innerHeight / 2)) < steps.offsetHeight) {
				progressBar.style.height = diff + (window.innerHeight / 2) + "px";
			}
		};

		// Initial call to set progress bar on page load
		updateProgressBar();

		// Add scroll event listener with passive option
		window.addEventListener("scroll", updateProgressBar, { passive: true });

	}

}); //end of DOM load